import React from "react";
import Styles from "./index.module.css";
import { companyProfile, location } from "../../../api";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import ModalChangePlant from "./modal/changePlant";
import ConfirmationDlg from "../../../components/ConfirmationDlg";
import { useAuth } from "../../../contexts/AuthContext.jsx";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";

import { renderImage, printLocation } from "../../../utils/helper.jsx";
import { useDashboardContext } from "../../../contexts/NewDashboardContext.jsx";
function PlantProfile() {
  const [isDirty, setIsDirty] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selected, setSelected] = useState(false);
  const [filteredCompany, setFilteredCompany] = useState(null);
  const [plants, setPlants] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [deleteRow, setDeleteRow] = useState(null);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const { updateLocations } = useDashboardContext();
  const { config } = useAuth();
  const clickAdd = () => {
    setOpenModal(true);
    setEditMode(false);
  };
  async function getCompany() {
    try {
      const res = await companyProfile.list();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.length) {
          if (!selected) {
            setSelected(data[0]);
            setFilteredCompany(data[0].uid);
          }

          let tmp = [];
          data.map((i, index) => {
            let item = i;
            tmp.push(item);
          });
          setCompanies(() => tmp);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  async function getPlant() {
    try {
      const res = await location.list("", true);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        updateLocations(data);
        setPlants([]);
        if (data.length) {
          if (!selected) {
            setSelected(data[0]);
          }

          let tmp = [];
          data.map((i, index) => {
            let item = i;
            tmp.push(item);
          });
          setPlants(() => tmp);
          setIsDirty(false);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  const onChangeCompany = (e) => setFilteredCompany(e.target.value);
  useEffect(() => {
    getCompany();
    getPlant();
  }, []);

  useEffect(() => {
    if (isDirty) {
      getCompany();
      getPlant();
    }
  }, [isDirty]);

  const onSubmitted = () => {
    setIsDirty(true);
  };
  function row(name, value) {
    return (
      <tr>
        <td style={{ fontSize: "12px", width: "100px" }}>{name}</td>
        <td style={{ width: "5px", textAlign: "center", fontSize: "12px" }}>
          :
        </td>
        <td className={"text-content-table"} style={{ fontSize: 12 }}>
          {value}
        </td>
      </tr>
    );
  }
  const editProfile = (row) => {
    setSelected(row);
    setOpenModal(true);
    setEditMode(true);
  };
  function showConfirmationDlg(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
    setConfirmDlg(false);
  }
  async function deleteFleet() {
    try {
      const response = await location.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();

        if (body.success) {
          toast.success(
            `This ${config?.location_wording.split(",")[0]} has been deleted`
          );
          setConfirmDlg(false);
          setDeleteRow(null);
        } else {
          toast.error(body.message);
        }

        setIsDirty(true);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  return (
    <>
      <div p={5} className="widget" style={{ height: "auto" }}>
        <div className="widget-wrapper" />
        <ModalChangePlant
          selected={selected}
          companies={companies}
          openModal={openModal}
          setOpenModal={setOpenModal}
          editMode={editMode}
          title={
            (editMode ? "Edit" : "Add") +
            ` ${config?.location_wording.split(",")[0]}`
          }
          onSubmitted={onSubmitted}
        />
        <div style={{ position: "relative" }}>
          <div className="row">
            <div className="col-sm-8"></div>
            <div className={"col-sm-4"}>
              <div
                style={{
                  width: "auto",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {/*<div style={{width: "185px"}}>
                                <FilterWhite
                                    label="Filter By"
                                    items={companies}
                                    value={filteredCompany || ""}
                                    onChange={onChangeCompany}
                                />
                            </div>*/}
                <btn
                  className="btn btn-outline-theme btn-sm mb-2"
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  onClick={clickAdd}
                >
                  Add {config?.location_wording.split(",")[0]}
                </btn>
              </div>
            </div>
          </div>

          <div mt={2}>
            <div className={"row"}>
              {plants.map((i, index) => (
                <div key={index} className="col-sm-4">
                  <div>
                    <Card className="bg-theme border-theme bg-opacity-25 mb-3">
                      <CardHeader className="border-theme fw-bold small text-white text-center">
                        {printLocation(i.location_name)}
                      </CardHeader>
                      <CardBody>
                        <div>
                          {/* <div
                            className="card-fe"
                            style={{
                              // backgroundImage: i.picture_url,
                              margin: "0 -11px",
                            }}
                          ></div> */}

                          <ImageViewer
                            src={i.picture_url}
                            style={{ width: "50px" }}
                          />
                        </div>
                        <div
                          style={{
                            textAlign: "left",

                            padding: "10px",
                          }}
                        >
                          {/*<div className={"col-sm-3 mb-1"}>*/}
                          {/*  <div display={"flex"}>*/}
                          {/*    <div*/}
                          {/*      className="trans-button"*/}
                          {/*      onClick={() => {*/}
                          {/*        editProfile(i);*/}
                          {/*      }}*/}
                          {/*    >*/}
                          {/*      Edit*/}
                          {/*    </div>*/}
                          {/*    <div*/}
                          {/*      className="trans-button"*/}
                          {/*      onClick={() => {*/}
                          {/*        showConfirmationDlg(i);*/}
                          {/*      }}*/}
                          {/*    >*/}
                          {/*      Delete*/}
                          {/*    </div>*/}
                          {/*  </div>*/}
                          {/*</div>*/}

                          <div>
                            <table
                              style={{ textAlign: "left" }}
                              className="tblRole"
                            >
                              <tbody>
                                {row("Address", i.location_address)}
                                {row("Contact Person", i.contact_person)}
                                {row("Contact Number", i.contact_number)}
                                {row("Email", i.contact_email)}
                              </tbody>
                            </table>
                          </div>
                          <div className="row mt-3 justify-content-center">
                            <div className="col-sm-6">
                              <button
                                onClick={() => {
                                  editProfile(i);
                                }}
                                className="btn btn-outline-light btn-sm w-100"
                              >
                                Edit
                              </button>
                            </div>
                            <div className="col-sm-5">
                              <button
                                onClick={() => {
                                  showConfirmationDlg(i);
                                }}
                                className="btn btn-outline-danger btn-sm w-100"
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {deleteRow && (
        <ConfirmationDlg
          title={`Delete ${config?.location_wording.split(",")[0]}`}
          open={confirmDlg}
          onClose={hideConfirmationDialog}
          onSubmit={deleteFleet}
        >
          <div style={{ pb: 2 }}>
            Are you sure you want to delete this{" "}
            {config?.location_wording.split(",")[0]}{" "}
            <strong>{deleteRow.name}</strong> ?
          </div>
        </ConfirmationDlg>
      )}
    </>
  );
}

export default PlantProfile;
